module.exports = __webpack_public_path__ + "static/img/manual-21.f041f6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-21.png
// module id = qULQ
// module chunks = 4